import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface SpacesHeaderProps {
  totalSpaces: number;
}

export function SpacesHeader({ totalSpaces }: SpacesHeaderProps) {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '2rem',
      }}
    >
      <div>
        <h1
          style={{
            fontSize: '2rem',
            fontWeight: 700,
            color: '#00303c',
            marginBottom: '0.5rem',
          }}
        >
          Espaces & Configuration
        </h1>
        <p style={{ fontSize: '0.95rem', color: '#666' }}>
          Gérez votre catalogue d'espaces : {totalSpaces} espace{totalSpaces !== 1 ? 's' : ''} au total.
        </p>
      </div>
      <button
        onClick={() => navigate('/spaces/new')}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          padding: '0.75rem 1.5rem',
          background: 'linear-gradient(135deg, #00758d 0%, #00303c 100%)',
          color: 'white',
          border: 'none',
          borderRadius: '12px',
          fontSize: '0.95rem',
          fontWeight: 600,
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0,117,141,0.3)',
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,117,141,0.4)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,117,141,0.3)';
        }}
      >
        <Plus size={18} />
        Nouvel espace
      </button>
    </div>
  );
}
